import React from "react";
import {Box, Skeleton} from "@mui/material";
import useGlobalContext from "../Hooks/useGlobalContext";

const Loading: React.FC = () => {

    const { loading } = useGlobalContext();

    if (!loading) {
        return <></>;
    }

    return (
        <Box
            position="absolute"
            top={0}
            left={0}
            bottom={0}
            right={0}
            display="flex"
            justifyContent="center"
            alignItems="center"
            bgcolor="rgba(255, 255, 255, 0.7)"
            zIndex={1}
        >
            <Skeleton variant="circular" width={40} height={40} />
        </Box>
    );
}

export default Loading;